export default __webpack_public_path__ + "images/7a6ac30d3437f6beb4d74f80359d7f5d.png";